import { type BaseItem, type Gender, type Specialty } from './common.js';
import { type LanguageWithOther } from './previsit/language.js';

export enum EducationKind {
  Undergraduate = 'UNDERGRADUATE',
  Graduate = 'GRADUATE',
  MedicalSchool = 'MEDICAL_SCHOOL',
  Residency = 'RESIDENCY',
  Fellowship = 'FELLOWSHIP',
}

export const EducationKindMap: {
  [education in EducationKind]: string;
} = {
  UNDERGRADUATE: 'Undergraduate',
  GRADUATE: 'Graduate',
  MEDICAL_SCHOOL: 'Medical School',
  RESIDENCY: 'Residency',
  FELLOWSHIP: 'Fellowship',
};

export interface Education {
  institution: string;
  kind: EducationKind;
  yearEnded?: string;
}

export const EDUCATION_TO_EDUCATION_KIND: Record<string, string> = {};
for (const [key, value] of Object.entries(EducationKindMap)) {
  EDUCATION_TO_EDUCATION_KIND[value] = key;
}

export interface Position {
  name: string;
  organization?: string;
  location?: string;
  years?: string;
}

export interface Certification {
  certification: string;
  institution?: string;
  year?: string;
}

export interface ProfessionalMembership {
  name: string;
}

export interface Publication {
  publication: string;
  publisher?: string;
  year?: string;
}

export interface Award {
  award: string;
  sponsor?: string;
  year?: string;
}

interface FullProfile {
  about: string;
  carePhilosophy: string;
  areasOfInterest: string;
  gender: Gender;
  pronouns: string;
  spokenLanguages: LanguageWithOther[];
  jobTitle: string;
  specialties: Specialty[];
  specialtiesRaw: string[];
  education: Education[];
  positions: Position[];
  certifications: Certification[];
  professionalMemberships: ProfessionalMembership[];
  publications: Publication[];
  awards: Award[];
}

export type Profile = Partial<FullProfile>;

export interface BaseProviderProfile {
  providerUserId: string;
  profile: Profile;
}

export interface ProviderProfile extends BaseItem, BaseProviderProfile {}
